import { useEffect, useState } from "react";
import { apiRequest } from "@/lib/api";
import type { Plan } from "@/data/plans";
import { annualTotal,money,type BillingCycle } from '@/lib/billing';

export function usePlanCatalog(initialCycle:BillingCycle='monthly') {
  type Row={id:string;slug?:string;name:string;price:number;duration_days:number;description:string;features:string[];highlight?:boolean;cta?:string;annual_enabled?:boolean;annual_discount_percent?:number;merakli_enabled?:boolean;meeting_enabled?:boolean;voice_coach?:boolean;parental_controls?:boolean};
  const [rows,setRows]=useState<Row[]>([]);
  const [cycle,setCycle]=useState<BillingCycle>(initialCycle);
  const [error,setError]=useState<string|null>(null);
  useEffect(()=>{
    let current=true;
    apiRequest<{packages: Row[]}>("/site/packages")
      .then(({packages})=>{if(current)setRows(packages);})
      .catch(e=>{if(current)setError(e.message);});
    return()=>{current=false;};
  },[]);
  const plans:Plan[]=rows.map(p=>{
    const paid=Number(p.price)>0;const yearly=paid&&cycle==='yearly'&&p.annual_enabled;
    const discount=Number(p.annual_discount_percent??0);const total=annualTotal(Number(p.price),discount);
    return {id:p.slug||p.id,name:p.name,price:paid?money(yearly?total:Number(p.price)):'Ücretsiz',
      period:paid?(yearly?'/ yıl, peşin':'/ ay'):'',description:p.description,features:(p.features||[]).map(feature=>/video.*arşiv|arşiv.*video/i.test(feature)?'Video içerikleri hazırlık aşamasında; hazır arşiv dahil değildir':feature),
      highlight:!!p.highlight,active:true,cta:p.cta||'Paketi incele',
      merakliEnabled:!!p.merakli_enabled,meetingEnabled:!!p.meeting_enabled,voiceCoach:!!p.voice_coach,parentalControls:!!p.parental_controls,
      billingNote:paid&&p.annual_enabled?`12 aylık peşin ödemeye %${discount} indirim`:undefined,
      oldPrice:yearly?money(Number(p.price)*12):undefined,savings:yearly?money(Number(p.price)*12-total)+' tasarruf':undefined};
  });
  return {plans,error,cycle,setCycle};
}
